import { authService } from "./auth";
import { functionBaseUrl } from "../common/firebase";

const baseUrl = functionBaseUrl.replace(/\/$/, "");

export const apiClient = {
  async request(path, options = {}) {
    const {
      body,
      headers = {},
      includeStatus = false,
      method = "GET",
      requireAuth = false,
    } = options;

    const url = `${baseUrl}${path}`;

    const init = {
      method,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: body != null ? JSON.stringify(body) : undefined,
    };

    if (requireAuth) {
      let token = null;

      const idToken = await authService.getIdToken(true);
      if (idToken) {
        token = idToken;
      } else {
        const stored = localStorage.getItem("currUser");
        if (stored) token = stored;
      }

      if (!token) throw new Error("Not authenticated");

      init.headers = {
        ...init.headers,
        Authorization: `Bearer ${token}`,
      };
    }

    try {
      const res = await fetch(url, init);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msg = data?.message || `HTTP ${res.status}`;
        throw new Error(msg);
      }
      return includeStatus ? { ...data, status: res.status } : data;
    } catch (err) {
      console.error(`Error ${method} ${url}:`, err);
      throw err instanceof Error ? err : new Error("Network error");
    }
  },
};
